import React, { useEffect, useState, useRef } from "react";
import * as S from "./styles";
import { Grid } from "@mui/material";
import SearchableSelect from "../../SearchableSelect";

const TimeLeft = (props) => {
  const { reload } = props;
  const Ref = useRef(null);
  const [timer, setTimer] = useState("00:00");

  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor(((total / 1000) * 60 * 60) % 24);
    return {
      total,
      hours,
      minutes,
      seconds,
    };
  };

  const startTimer = (e) => {
    let { total, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      setTimer(
        (minutes > 9 ? minutes : "0" + minutes) +
          ":" +
          (seconds > 9 ? seconds : "0" + seconds)
      );
      if (minutes == 0 && seconds == 0) {
        clearInterval(Ref.current);
        reload();
        reset();
      }
    }
  };

  const clearTimer = (e) => {
    const v = selectedSearchInterval.value;
    setTimer((v < 10 ? "0" + v : v) + ":00");
    if (Ref.current) {
      clearInterval(Ref.current);
    }
    const id = setInterval(() => {
      console.log("aqui: " + Ref.current);
      startTimer(e);
    }, 1000);
    Ref.current = id;
  };

  const stop = () => {
    if (Ref.current) {
      clearInterval(Ref.current);
    }
    Ref.current = null;
  };

  const reset = () => {
    clearTimer(getDeadTime());
  };

  const getDeadTime = () => {
    let deadline = new Date();
    deadline.setSeconds(
      deadline.getSeconds() + selectedSearchInterval.value * 60
    );
    return deadline;
  };

  const searchIntervals = [
    { value: 0, label: "Desativado" },
    { value: 5, label: "5 minutos" },
    { value: 10, label: "10 minutos" },
    { value: 15, label: "15 minutos" },
  ];
  const [selectedSearchInterval, setSelectedSearchInterval] = useState(
    searchIntervals[0]
  );

  useEffect(() => {
    if (selectedSearchInterval.value > 0) {
      reset();
    } else {
      stop();
    }
  }, [selectedSearchInterval]);

  return (
    <>
      <Grid item xs={12} md={3} lg={2}>
        <SearchableSelect
          entries={searchIntervals}
          isDisabled={false}
          isLoading={false}
          label="Intervalo de busca"
          placeholder="Desativado"
          selected={selectedSearchInterval}
          setSelected={setSelectedSearchInterval}
        />
      </Grid>
      <Grid item xs={12} md={3} lg={2}>
        {selectedSearchInterval.value > 0 && (
          <S.Container>
            <S.Wrapper>
              <S.Label className="labelInputBordered">Recarregando em:</S.Label>
              <S.Timer>{timer}</S.Timer>
            </S.Wrapper>
          </S.Container>
        )}
      </Grid>
    </>
  );
};

export default TimeLeft;
